import { F0ButtonToggle } from '@factorialco/f0-react'
import { Microphone, MicrophoneNegative } from '@factorialco/f0-react/icons/app'
import { usePersistentUserChoices } from '@livekit/components-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

export const PreConnectMicrophoneButton = () => {
  const { userChoices, saveAudioInputEnabled } = usePersistentUserChoices()

  return (
    <F0ButtonToggle
      icon={userChoices.audioEnabled ? Microphone : MicrophoneNegative}
      label={i18n.t('common.ai.voice.control_bar.microphone.label')}
      onSelectedChange={(selected: boolean) => {
        track(trackingEvents.meetings.ControlBarMuteButton, {
          isMuted: !selected,
        })
        saveAudioInputEnabled(selected)
      }}
      size="md"
      selected={userChoices.audioEnabled}
    />
  )
}
